import { makeStyles } from '@material-ui/core';

import classNames from 'classnames';

import { Tag, TagGroup } from '@backstage/ui';

import { describeCriterion, hasChanged } from './formatting';
import { Criterion } from './types';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    gap: 'var(--bui-space-2)',
    alignItems: 'center',
    fontSize: '0.8125rem',
    padding: 'var(--bui-space-1) 0',
  },
  unchanged: {
    opacity: 0.5,
  },
  oldValue: {
    color: 'var(--bui-fg-secondary)',
    textDecoration: 'line-through',
  },
  newValue: {
    color: 'var(--bui-fg-success)',
  },
});

export const CriterionDiff = ({
  oldCriterion,
  newCriterion,
}: {
  oldCriterion: Criterion | undefined;
  newCriterion: Criterion | undefined;
}) => {
  const classes = useStyles();

  const criterion = newCriterion ?? oldCriterion;
  if (!criterion) return null;

  const changed = hasChanged(oldCriterion, newCriterion);

  const info = describeCriterion(criterion);

  if (!changed) {
    return (
      <div className={classNames(classes.root, classes.unchanged)}>
        <TagGroup aria-label="Criterion type">
          <Tag size="small">{info.tagLabel}</Tag>
        </TagGroup>
        <span>{info.value}</span>
      </div>
    );
  }

  const oldInfo = oldCriterion ? describeCriterion(oldCriterion) : null;
  const newInfo = newCriterion ? describeCriterion(newCriterion) : null;

  return (
    <div className={classes.root}>
      <TagGroup aria-label="Criterion type">
        <Tag size="small">{info.tagLabel}</Tag>
      </TagGroup>
      {oldInfo && <span className={classes.oldValue}>{oldInfo.value}</span>}
      {newInfo && <span className={classes.newValue}>{newInfo.value}</span>}
    </div>
  );
};
